import {products} from './feature.products.svelte.js';
import {booking} from '../booking/feature.booking.svelte.js';
import {page_json, progress} from '../progress/feature.progress.svelte.js';
import * as products_update from './products.scenarios.update.svelte.js';
import * as money_util from '../../utils/MoneyUtil.js';
import * as debug_actions from "../debug/actions_debug.svelte.js";
import * as progress_select from "../progress/progress.scenarios.select.svelte.js";
import DateTimeUtil from "../../utils/DateTimeUtil.js";

export function apiCallTreatmentsSuccess(html)
{
  debug_actions.debugAddLogFlow('products', 'apiCallTreatmentsSuccess', {html});
  progress.bIsFetchingTreatments = false;
  //InputUtil.updateProductsStateWithExternalTreatmentsInput(html);
}

export function apiCallRequestEntryPriceForDate(iBuyableID)
{
  // debug_actions.debugAddLogFlow('products', 'apiCallRequestEntryPriceForDate', {iBuyableID});
  // products_update.scenarioUpdateProductPriceForTodayWithoutRemoteCheck(iBuyableID);
}

export function updateProductPriceForDay(oData)
{
  // console.log('updateProductPriceForDay', oData);
  debug_actions.debugAddLogFlow('products', 'updateProductPriceForDay', {oData});
  const {iPrice, iBuyableID, sStartDate} = oData;
  const sCurrentArrivalDate = booking.sArrivalDate;

  if ( sStartDate === sCurrentArrivalDate )
  {
    if ( iPrice && iBuyableID )
    {
      products_update.scenarioUpdateProductPriceByID(
        iBuyableID,
        iPrice
      );
    }
  }
}

export function importFromOfAjaxCall(html)
{
  debug_actions.debugAddLogFlow('products', 'importFromOfAjaxCall');
  const htmlTreatments = '<div>' + html + '</div>'; // jquery heeft container nodig
  const aListsRefs = []; // een array met setjes

  jQuery(htmlTreatments).find(".subcat").each((index, elementSubcat) => {
    const aItems = [];

    jQuery(elementSubcat).find('.product').each((index, elementProduct) => {

      let htmlContent = '';
      const elContent = jQuery(elementProduct).find('.product__reservation-content'); // lange tekst
      if ( elContent ) htmlContent = elContent.html();

      let oImage = false;
      const elTeaserImage = jQuery(elementProduct).find('.product__teaserimg img');
      if ( elTeaserImage ) oImage = elTeaserImage.attr('src');
      const bIsDebugModeEnabled = progress_select.isDebugModeEnabled();
      if ( typeof oImage === 'undefined' || oImage === false && bIsDebugModeEnabled === true )
      {
        // Fallback afbeelding
        oImage = progress.sImageURLProduct;
      }

      // Voor nu intitieel op beschikbaar zetten als data-availability attribuut ontbreekt (content-only response)
      // De availability call die we later doen na de tijdselectie heeft de exacte beschikbaarheid
      let bIsAvailable = true;
      let sIsAvailable = jQuery(elementProduct).attr('data-availability');

      if ( typeof sIsAvailable !== 'undefined' && sIsAvailable !== "available" )
      {
        bIsAvailable = false;
      }

      let bIsPreselected = false;
      let sIsPreselected = jQuery(elementProduct).attr('data-preselected');

      if ( sIsPreselected === true || sIsPreselected === "true" )
      {
        bIsPreselected = true;
      }

      let bIsTreatment = false;
      let sIsTreatment = jQuery(elementProduct).attr('data-is-treatment');

      if ( sIsTreatment === true || sIsTreatment === "true" )
      {
        bIsTreatment = true;
      }

      const htmlSummary = jQuery(elementProduct).find('.product__summary').html();

      let oProductConfig = {
        iID: parseInt(jQuery(elementProduct).attr('data-id')),
        sTitle: jQuery(elementProduct).find('.product__title').text(),
        iPrice: money_util.stringToCents(jQuery(elementProduct).attr('data-price')),
        sPrice: jQuery(elementProduct).attr('data-price'),
        sPriceString: jQuery(elementProduct).attr('data-price-string') || null,
        bIsPreselected: bIsPreselected, // is in de categorie al door PHP bovenaan gezet.. dit is nog voor weergave zoals het toevoegen van een class voor styling
        bIsAvailable: bIsAvailable,
        bIsTreatment: bIsTreatment,
        sDateUsed: DateTimeUtil.convertYYYYdashMMdashDDToDDdashMMdashYYYY(jQuery(elementProduct).attr('data-date')),
        htmlSummary: htmlSummary,
        htmlContent: htmlContent,
        sImage: oImage
      };

      aItems.push(oProductConfig);
    });


    let bIsPreselectedCat = false;
    let sIsPreselectedCat = jQuery(elementSubcat).attr('data-preselected');

    if ( sIsPreselectedCat === true || sIsPreselectedCat === "true" )
    {
      bIsPreselectedCat = true;
    }

    const oSubcatData = {
      sID: jQuery(elementSubcat).attr('data-id'),
      sTitle: jQuery(elementSubcat).find('.subcat__title').text(),
      lItems: aItems,
      bIsPreselected: bIsPreselectedCat
    };
// console.log('floep 2', oSubcatData);
    aListsRefs.push(oSubcatData);
  });

  products.lAvailableTreatments = aListsRefs;

  // If Phase 2 availability already completed before this (Phase 1) content landed — the race in the
  // deeplink/arrangement flow where treatments content is not pre-fetched — its merged prices were just
  // wiped by the reassignment above. Re-apply the stored availability, but ONLY when it was fetched for
  // the still-active date/time/people; otherwise leave it and let a fresh Phase 2 fill it in.
  const oLastAvailability = products.oLastTreatmentsAvailability;
  if (
    products.bHasTreatmentsAvailability
    && oLastAvailability
    && oLastAvailability.sDate === booking.sArrivalDate
    && oLastAvailability.iArrivalTime === booking.iArrivalTime
    && oLastAvailability.iDepartureTime === booking.iDepartureTime
    && oLastAvailability.iNrOfPeople === booking.iNrOfPeople
  )
  {
    applyTreatmentsAvailabilityData(oLastAvailability.oData, oLastAvailability.sDate);
  }

  // in deze html zit mogelijk ook informatie over beschikbare restaurant tijdslots
  const aRestaurantSlots = []; // een array met setjes
  jQuery(htmlTreatments).find(".js-restaurant-timeslot").each((index, elementRestaurantTimeSlot) => {
    const oTimeSlotData = {
      iTimeStart: parseInt(jQuery(elementRestaurantTimeSlot).attr('data-start')),
      iTimeEnd: parseInt(jQuery(elementRestaurantTimeSlot).attr('data-end'))
    }

    aRestaurantSlots.push(oTimeSlotData);
  });

  products.lRestaurantSlots = aRestaurantSlots;
}

/**
 * Merge Phase-2 availability/price data onto the already-loaded lAvailableTreatments items.
 *
 * Split out of fetchTreatmentsAvailability (actions_remote) so it can be re-applied when Phase-1
 * content (re)populates lAvailableTreatments AFTER Phase-2 already ran — see the guarded call in
 * importFromOfAjaxCall(). Idempotent: applying the same data twice yields the same result.
 *
 * @param {object} oAvailabilityData - The aProducts map from the productsAvailability response.
 * @param {string} sDate - The date the availability was fetched for (stamped onto each item).
 */
export function applyTreatmentsAvailabilityData(oAvailabilityData, sDate)
{
  const bForceAvailableDev = window.hmk_bForceAvailableTreatments === true;

  products.oAvailabilityByProductID = Object.fromEntries(
    Object.entries(oAvailabilityData || {}).map(([sProductID, oAvailability]) => {
      const bIsAvailable = bForceAvailableDev
        ? true
        : (oAvailability.bAvailable === true && oAvailability.iPrice !== -1);

      return [parseInt(sProductID, 10), {
        bIsAvailable,
        iPrice: oAvailability.iPrice === -1 ? -1 : Math.round(oAvailability.iPrice * 100),
        sPriceString: oAvailability.sPriceString || null,
        iSpotsAvailable: oAvailability.iSpotsAvailable,
        sDateUsed: sDate
      }];
    })
  );

  products.lAvailableTreatments.forEach(oCategory => {
    oCategory.lItems.forEach(oProduct => {
      const oAvail = oAvailabilityData[oProduct.iID];
      if ( oAvail )
      {
        // Available only if the API explicitly says bAvailable === true AND the price is not the -1
        // sentinel (iPrice === -1 historically means "not available" / "price on request").
        const bNewIsAvailable = (oAvail.bAvailable === true) && oAvail.iPrice !== -1;
        oProduct.bIsAvailable = bForceAvailableDev ? true : bNewIsAvailable;

        // API returns price in euros, frontend works with cents - convert (keep -1 sentinel as-is).
        if ( oAvail.iPrice !== undefined )
        {
          oProduct.iPrice = oAvail.iPrice === -1 ? -1 : Math.round(oAvail.iPrice * 100);
        }
        if ( oAvail.sPriceString !== undefined ) oProduct.sPriceString = oAvail.sPriceString || null;

        // Multi-person treatments: max spots available across the day's slots, only present for
        // flagged products. The productset card gates on it (>= iNrOfPeopleExact).
        if ( oAvail.iSpotsAvailable !== undefined ) oProduct.iSpotsAvailable = oAvail.iSpotsAvailable;

        // Stamp the date so receipt calculation knows this data is for the current date.
        oProduct.sDateUsed = sDate;
      }
      else
      {
        // Product not in Phase 2 response = unavailable for this date/time.
        oProduct.bIsAvailable = bForceAvailableDev ? true : false;
      }
    });
  });

  if ( bForceAvailableDev )
  {
    console.log('[DEV] hmk_bForceAvailableTreatments=true: alle behandelingen geforceerd op bIsAvailable=true');
  }
}


export function importFromPageConfigAjaxCall()
{
  // De aanbevolen producten
  if ( typeof page_json.data.jsonHmkRecProducts !== 'undefined' )
  {
    products.aRecommendedProductIDs = page_json.data.jsonHmkRecProducts;
  }

  // De productcatalogus
  let aStateItems = products.lItems;

  if ( typeof page_json.data.jsonHmkCatalogueProducts === 'undefined' )
  {
    //DebugUtil.log('jsonHmkCatalogueProducts undefined', DebugUtil.DEBUG_CAT_ERRORS_GENERAL);
    //window.console.log('jsonHmkCatalogueProducts undefined', DebugUtil.DEBUG_CAT_ERRORS_GENERAL);
  }
  else
  {
    const oInput = page_json.data.jsonHmkCatalogueProducts;

    //window.console.log('jsonHmkCatalogueProducts verwerken!', DebugUtil.DEBUG_CAT_ERRORS_GENERAL, page_json.data.jsonHmkCatalogueProducts);

    if ( oInput !== false )
    {
      let oProduct, iProductID;
      oInput.forEach((oValFromJSON, sKeyFromJson) => {
        if ( typeof oValFromJSON.ID !== 'undefined' )
        {
          oProduct = {};
          iProductID = parseInt(oValFromJSON.ID);

          // DefaultTime: "10:00"
          // ID: "47"
          // PersMax: "1"
          // PersMin: "1"
          // Price: "0.00"
          // Title: "Entree arrangementen"
          // Together: "0"
          // IsProductWithoutSauna: "0"
          // eventueel: IsEntry= 1

          const idx = aStateItems.findIndex((oAlreadyAddedProduct) => oAlreadyAddedProduct.iID === iProductID);

          // alleen product toevoegen als we die nog niet hebben (ook ivm onbedoeld meerdere keren parsen)
          if ( idx === -1 )
          {
            oProduct.iID = iProductID;

            if ( typeof oValFromJSON.Ti !== 'undefined' ) oProduct.sTitle = oValFromJSON.Ti;
            if ( typeof oValFromJSON.Pr !== 'undefined' ) oProduct.iPrice = money_util.stringToCents(oValFromJSON.Pr);

            // console.log(
            //   'debugprod',
            //   parseInt(oValFromJSON.ID),
            //   oValFromJSON.Pr,
            //   money_util.stringToCents(oValFromJSON.Pr)
            // );

            oProduct.bIsEntry = false;
            if ( typeof oValFromJSON.Ent !== 'undefined' && oValFromJSON.Ent === "1" || oValFromJSON.Ent === 1 ) oProduct.bIsEntry = true;

            oProduct.bIsProductWithoutSauna = false;
            if ( typeof oValFromJSON.NoSau !== 'undefined' && oValFromJSON.NoSau === "1" || oValFromJSON.NoSau === 1 ) oProduct.bIsProductWithoutSauna = true;

            oProduct.bIsTreatment = false;
            if ( typeof oValFromJSON.IsTr !== 'undefined' && oValFromJSON.IsTr === "1" || oValFromJSON.IsTr === 1 ) oProduct.bIsTreatment = true;

            // Duur in minuten — door de PHP-kant altijd meegestuurd (kan 0 zijn voor producten zonder gedefinieerde duur, zoals entrees)
            oProduct.iDuration = 0;
            if ( typeof oValFromJSON.Dur !== 'undefined' ) oProduct.iDuration = parseInt(oValFromJSON.Dur) || 0;

            // (VOf / iVariantOf is verwijderd: sets komen nu volledig uit de ProductSet-descriptors.)

            // TitleIfDuo: alternatieve titel voor weergave als anker in een productset-card.
            if ( typeof oValFromJSON.TiDuo !== 'undefined' ) oProduct.sTitleIfDuo = oValFromJSON.TiDuo;

            // Multi-person treatments ("behandelingen voor koppels"): exact required number of
            // people (0 = no constraint) and whether a shared timeslot must be chosen. Both are
            // only sent by the backend for flagged Sweetlake products; default to the legacy
            // (single-person) behaviour when absent.
            oProduct.iNrOfPeopleExact = 0;
            if ( typeof oValFromJSON.iNrPE !== 'undefined' ) oProduct.iNrOfPeopleExact = parseInt(oValFromJSON.iNrPE) || 0;

            oProduct.bIsTimeSelectionRequired = false;
            if ( typeof oValFromJSON.bTsReq !== 'undefined' && (oValFromJSON.bTsReq === true || oValFromJSON.bTsReq === 'true' || oValFromJSON.bTsReq === 1 || oValFromJSON.bTsReq === '1') ) oProduct.bIsTimeSelectionRequired = true;
          }

          aStateItems.push(oProduct);
        }
      });
    }
  }

  products.lItems = aStateItems;
}
